<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { validateStepOneData, getFormValues, postValidateStepOneData } from "./step-one.model.js";
  import { Stores } from "../../stores/stores.js";

  const dispatch = createEventDispatcher();

  const subConditionFilePath = "files/SFAPEC_conditions_de_souscription.pdf";
  const noticeFilePath = "files/SFAPEC_notice_information.pdf";
  const FDDCFilePath = "files/SFAPEC_FDDC.pdf";
  const rgpdFilePath = "files/SFAPEC_RGPD.pdf";

  let errorMsg = null;
  let warningMsg = null;
  let isIndiv = null;
  const indivPrice = "186,85";
  const societePrice = "280";
  const contactEmailHref = "lba@lbaconseil.fr";

  function formSubmit(event) {
    errorMsg = null;
    warningMsg = null;
    const formData = { ...getFormValues(event), isIndiv };

    const error = validateStepOneData(formData);
    const warning = postValidateStepOneData(formData);

    if (error) {
      errorMsg = error;
      return;
    }

    if (warning) {
      warningMsg = warning;
      return;
    }

    Stores.set({
      chiffreAffaire: formData.chiffreAffaire,
      isIndiv: Boolean(formData.isIndiv)
    });

    dispatch("nextStep");
  }

</script>

<div>
  <h3 class="title">Tarification</h3>

  <form on:submit|preventDefault={formSubmit}>
    <div class="form-group">
      <div class="form-label">Êtes-vous auto-entrepreneur ?</div>
      <div>
        <div class="form-check-inline">
          <input class="form-check-input" type="radio" name="isIndiv" id="isAutoRadio"
                 value="{isIndiv}" on:click={()=>{isIndiv = true}}>
          <label class="form-check-label" for="isAutoRadio">Oui</label>
        </div>
        <div class=" form-check-inline">
          <input class="form-check-input" type="radio" name="isIndiv" id="isNotAutoRadio"
                 value="{isIndiv}" on:click={()=>{isIndiv = false}}>
          <label class="form-check-label" for="isNotAutoRadio">Non</label>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label for="chiffreAffaire" class="form-label">Quel est votre chiffre d'affaire prévisionnel (en € HT) ?</label>
      <input type="number" min="0" class="form-control" id="chiffreAffaire" name="chiffreAffaire">
    </div>


    <div class="form-check">
      <input type="checkbox" class="form-check-input" id="readSubConditions" name="readSubConditions">
      <label for="readSubConditions" class="form-check-label">
        Je déclare valider <a target="_blank" href="{subConditionFilePath}">les conditions de souscription</a>.
      </label>
    </div>


    <div class="form-check">
      <input type="checkbox" class="form-check-input" id="readNotice" name="readNotice">
      <label for="readNotice" class="form-check-label">
        J'ai pris connaissance de la <a target="_blank" href="{noticeFilePath}">notice d'information</a> valant
        conditions générales, et j'accepte l'intégralité des termes.
      </label>
    </div>


    <div class="form-check">
      <input type="checkbox" class="form-check-input" id="readFDDC" name="readFDDC">
      <label for="readFDDC" class="form-check-label">
        J'ai pris connaissance de la <a target="_blank"
                                        href={FDDCFilePath}>formalisation
        du devoir de conseil</a>
        et de <a target="_blank" href={rgpdFilePath}>l'information RGPD</a>, et j'accepte l'intégralité des termes.
      </label>
    </div>

    {#if isIndiv !== null && !warningMsg}
      <div class="bg-primary-subtle p-2 text-center mt-4 rounded-1">
        <p class="text-body-secondary m-0">Tarif annuel : <b class="fs-5">{isIndiv ? indivPrice : societePrice} €</b>&nbsp;TTC
        </p>
      </div>
    {/if}
    {#if errorMsg}
      <div class="bg-danger-subtle p-2 text-center text-danger mt-4 rounded-1">
        {errorMsg}
      </div>
    {/if}
    {#if warningMsg}
      <div class="bg-warning-subtle p-2 text-center text-body-secondary mt-4 rounded-1">
        <p class="m-0">{warningMsg.text}</p>
        {#if warningMsg.showContact}
          <a class="link-primary" href="mailto:{contactEmailHref}">Veuillez contacter LBA</a>
        {/if}
      </div>
    {/if}

    <footer class="text-center mt-4">
      <button type="submit" class="btn btn-primary">Continuer</button>
    </footer>
  </form>
</div>

<style>

  .title {
    background-color: #A5C641;
    color: white;
    padding: 4px 20px;
    font-weight: 400;
    font-size: 16px;
    width: max-content;
  }

    .form-group, .form-check {
        margin: 1rem 0;
    }

    .form-label {
        margin-bottom: 8px;
      font-size: 14px;
      color: #626262;
    }
</style>
